export enum Mode {
  ArabicEnglishRows,
  ArabicEnglishColumns,
  ArabicOnly,
  EnglishOnly
}
